const cb150Data = {
  slug: "cb150-verza",
  name: "Honda CB150 Verza",

  hero: {
    shortDescription:
      "Motor sport naked 150cc dengan desain maskulin, tangguh, dan nyaman untuk penggunaan harian",

    variants: [
      {
        key: "sw-black",
        label: "SW",
        fullName: "Honda CB150 Verza SW Masculine Black",
        startPrice: 24404000,
      },
      {
        key: "cw-black",
        label: "CW",
        fullName: "Honda CB150 Verza CW Macho Matte Black",
        startPrice: 25034000,
      },
      {
        key: "cw-red",
        label: "CW",
        fullName: "Honda CB150 Verza CW Bold Red",
        startPrice: 25034000,
      },
    ],

    slides: [
      {
        variantKey: "sw-black",
        image: "/assets/motor/produk/cb150verza/Honda-CB150-Verza-SW-Masculine-Black.webp",
        specs: {
          engine: "149,2 cc, 4 Langkah, SOHC, PGM-FI",
          power: "9,59 kW (13,0 PS) / 8.500 rpm",
          smartKey: false,
        },
      },
      {
        variantKey: "cw-black",
        image: "/assets/motor/produk/cb150verza/Honda-CB150-Verza-CW-Macho-Matte-Black.webp",
        specs: {
          engine: "149,2 cc, 4 Langkah, SOHC, PGM-FI",
          power: "9,59 kW (13,0 PS) / 8.500 rpm",
          smartKey: false,
        },
      },
      {
        variantKey: "cw-red",
        image: "/assets/motor/produk/cb150verza/Honda-CB150-Verza-CW-Bold-Red.webp",
        specs: {
          engine: "149,2 cc, 4 Langkah, SOHC, PGM-FI",
          power: "9,59 kW (13,0 PS) / 8.500 rpm",
          smartKey: false,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda CB150 Verza merupakan motor sport naked yang dirancang untuk memberikan kenyamanan berkendara harian dengan karakter mesin yang tangguh dan perawatan yang mudah.",
      },
      {
        type: "paragraph",
        text:
          "Ditenagai mesin 150cc berpendingin udara dengan sistem injeksi PGM-FI, CB150 Verza menawarkan performa halus, irit bahan bakar, serta respons mesin yang stabil untuk berbagai kebutuhan berkendara.",
      },
      {
        type: "heading",
        text: "Desain Maskulin dan Fungsional",
      },
      {
        type: "paragraph",
        text:
          "Tampilan CB150 Verza diperkuat dengan desain tangki besar, lampu depan bulat klasik, serta posisi berkendara yang tegak dan nyaman untuk perjalanan jarak dekat maupun jauh.",
      },
      {
        type: "heading",
        text: "Tangguh untuk Aktivitas Sehari-hari",
      },
      {
        type: "paragraph",
        text:
          "Struktur rangka yang kuat dan suspensi yang empuk membuat Honda CB150 Verza cocok digunakan di berbagai kondisi jalan, termasuk penggunaan komuter harian.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Mesin", "4 Langkah, SOHC, Pendingin Udara"],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Kapasitas Mesin", "149,2 cc"],
      ["Daya Maksimum", "9,59 kW (13,0 PS) / 8.500 rpm"],
      ["Torsi Maksimum", "12,73 Nm / 6.000 rpm"],
      ["Transmisi", "Manual, 5 Percepatan"],
    ],

    rangka: [
      ["Tipe Rangka", "Diamond Steel Frame"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Suspensi Belakang Ganda"],
      ["Rem Depan", "Cakram"],
      ["Rem Belakang", "Tromol"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "2.056 x 742 x 1.054 mm"],
      ["Tinggi Jok", "773 mm"],
      ["Jarak Sumbu Roda", "1.318 mm"],
      ["Berat", "129–130 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "12 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "DC-CDI"],
      ["Tipe Aki", "12V MF"],
      ["Sistem Starter", "Electric & Kick Starter"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda CB150 Verza",
    items: [
      {
        title: "Mesin 150cc PGM-FI",
        desc:
          "Mesin berpendingin udara yang tangguh, irit bahan bakar, dan mudah dalam perawatan.",
      },
      {
        title: "Desain Tangki Besar",
        desc:
          "Tangki berkapasitas besar dengan tampilan maskulin yang mendukung perjalanan lebih jauh.",
      },
      {
        title: "Suspensi Nyaman",
        desc:
          "Suspensi depan teleskopik dan suspensi belakang ganda untuk kenyamanan berkendara harian.",
      },
      {
        title: "Panel Meter Analog",
        desc:
          "Panel meter analog yang informatif dan mudah dibaca.",
      },
      {
        title: "Rangka Diamond Steel",
        desc:
          "Rangka kokoh yang memberikan stabilitas dan ketahanan untuk penggunaan jangka panjang.",
      },
    ],
  },
};

export default cb150Data;
